import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { DataSchemaClient, EnumModel } from '../../../api/api';
import useApiClient from '../../../common/hooks/useApiClient';

export default function useApiEnumsOfContext(contextId: string | undefined): UseQueryResult<EnumModel[], Error> {
    const client = useApiClient(DataSchemaClient);
    const enums = useQuery({
        queryKey: ['flow', 'enums', contextId],
        queryFn: () => (contextId ? client.getEnums(contextId) : []),
    });

    return enums;
}
